// AUTO-GENERATED from "Medicine matrix Version 2.xlsx" (classical Ayurvedic medicine matrix).
// Static prototype data. When this graduates past prototype, move it to a backend/DB.

const MEDICINE_MATRIX = {
  "forms": [
    {
      "label": "Vati / Tablet",
      "sub": "Solid forms"
    },
    {
      "label": "Churna",
      "sub": "Powder"
    },
    {
      "label": "Kwatha",
      "sub": "Decoction"
    },
    {
      "label": "Arishta / Asava",
      "sub": "Fermented"
    },
    {
      "label": "Ghrita / Taila",
      "sub": "Oils & Ghee"
    },
    {
      "label": "Rasaushadhi",
      "sub": "Mineral-Metal"
    },
    {
      "label": "Anupana",
      "sub": "Adjuvant"
    }
  ],
  "sourceLabel": "Classical source",
  "sections": [
    {
      "section": "DOSHA — Constitutional Balance",
      "rows": [
        {
          "name": "VATA",
          "note": "(Air+Space Movement, Dryness)",
          "cells": [
            [
              "Vatari Gutika",
              "Simhanada Guggulu",
              "Yogaraj Guggulu",
              "Mahayogaraj Guggulu",
              "Rasnasaptaka Gutika",
              "Trayodashanga Guggulu",
              "Vatavidhvamsa Rasa"
            ],
            [
              "Ashwagandha Churna",
              "Dashamoola Churna",
              "Bala Churna",
              "Rasna Churna",
              "Eranda Churna",
              "Ajamoda Churna",
              "Trikatu Churna"
            ],
            [
              "Dashamoola Kwatha",
              "Rasnasaptaka Kwatha",
              "Guduchyadi Kwatha",
              "Balaadi Kwatha",
              "Panchmoola Kwatha (BRV p.100)",
              "Vajrasena Kwatha (BRV p.100)",
              "Guduchyadi Kwatha-Harita (BRV p.100)",
              "Balaaswagandhadi Kwatha"
            ],
            [
              "Balarishta",
              "Dashmoolaishta",
              "Ashwagandharishta",
              "Eranda Taila Sneha",
              "Saraswatarishta",
              "Lohasava"
            ],
            [
              "Mahanarayan Taila",
              "Dhanvantara Taila",
              "Ksheerabala Taila (Sahasra Yoga p.70)",
              "Sahacharadi Taila",
              "Bala Taila",
              "Ajamamsa Ghritam (SY p.232)",
              "Maha Mayura Ghritam (SY p.231)",
              "Prasaranyadi Taila"
            ],
            [
              "Vatakukulantak Rasa",
              "Ekanga Veer Rasa",
              "Mahavata Vidhwansan Rasa",
              "Brihad Vata Chintamani",
              "Sameer Pannaga Rasa",
              "Abhraka Bhasma"
            ],
            [
              "Warm sesame oil",
              "ghee, warm milk",
              "eranda (castor oil)",
              "urad dal water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Vatavyadhi Chikitsa",
            "Sahasra Yoga -- Ksheerabala Taila p.70; Ajamamsa Ghritam p.232; Maha Mayura Ghritam p.231",
            "Baisajyaratnavali -- Vatavyadhi pp.100-101",
            "Ashtanga Hridaya -- Vatavyadhi Chikitsa"
          ]
        },
        {
          "name": "PITTA",
          "note": "(Fire+Water Heat, Metabolism)",
          "cells": [
            [
              "Kamdudha Rasa",
              "Praval Panchamrit Rasa",
              "Shatavari Gutika",
              "Chandanasava Tablet",
              "Nalpamaradi Tablet",
              "Giloy Sat Tablet",
              "Amalaki Rasayan Tablet"
            ],
            [
              "Chandana Churna",
              "Amalaki Churna",
              "Shatavari Churna",
              "Usheera Churna",
              "Kama Dudha Churna",
              "Triphala Churna",
              "Praval Pishti Churna"
            ],
            [
              "Chandanadi Kwatha",
              "Nimbadi Kwatha",
              "Tiktadi Kwatha-Bhavaprakasha (BRV p.101)",
              "Parpatakadi Kwatha-Chakradatta (BRV p.101)",
              "Mahadrakshaadi Kwatha (BRV p.102)",
              "Useerasava related Kwatha",
              "Tikta Dravya Kwatha",
              "Satavari Kwatha"
            ],
            [
              "Chandanasava",
              "Useerasava",
              "Kumaryasava",
              "Drakshasava",
              "Parthadyarishta",
              "Lohasava"
            ],
            [
              "Chandanadi Ghrita",
              "Tikta Ghrita",
              "Mahatikta Ghrita",
              "Jatyadi Ghrita",
              "Shatavari Ghrita",
              "Brahmi Ghrita",
              "Kumarya Asava Sneha"
            ],
            [
              "Kamdudha Rasa",
              "Praval Panchamrit Rasa",
              "Mukta Pishti",
              "Praval Pishti",
              "Abhraka Bhasma Shataputi",
              "Suvarna Sutashekhar Rasa",
              "Suvarna Malini Vasant"
            ],
            [
              "Coconut water",
              "pomegranate juice",
              "cow milk, mishri",
              "usheera decoction"
            ]
          ],
          "source": [
            "Charaka Samhita -- Pittavyadhi Chikitsa",
            "Baisajyaratnavali -- Pittaroga pp.101-102 (Tiktadi, Parpatakadi, Mahadrakshaadi Kwatha)",
            "Ashtanga Hridaya -- Pittavyadhi",
            "Bhavaprakasha -- Pittahara Dravyas"
          ]
        },
        {
          "name": "KAPHA",
          "note": "(Water+Earth Structure, Mucus)",
          "cells": [
            [
              "Kanchanar Guggulu",
              "Triphala Guggulu",
              "Medohar Guggulu",
              "Trikatu Vati",
              "Chitrakadi Vati",
              "Shilajit Tablet",
              "Varunadi Gutika"
            ],
            [
              "Trikatu Churna",
              "Triphala Churna",
              "Vidanga Churna",
              "Haridra Churna",
              "Pushkaramoola Churna",
              "Vacha Churna",
              "Guggulu Churna"
            ],
            [
              "Varunadi Kwatha",
              "Punarnavadi Kwatha",
              "Saptachhadi Kwatha-Sushruta (BRV p.106)",
              "Vasadi Kwatha-Bhavaprakasha",
              "Nimbadi Kwatha-Chakradatta",
              "Marichadi Kwatha",
              "Mustaadi Kwatha",
              "Kapha Nashaka Kwatha"
            ],
            [
              "Kanakasava",
              "Lohasava",
              "Punarnavasava",
              "Arjunarishta",
              "Dashamoolarishta",
              "Vasarishta"
            ],
            [
              "Nirgundi Taila",
              "Trikatu Ghrita",
              "Tumbi Taila",
              "Vyoshadi Ghrita",
              "Karpuradi Taila",
              "Tulasi Taila",
              "Sasthika Taila"
            ],
            [
              "Shilajit Shuddha",
              "Tamra Bhasma",
              "Abhraka Bhasma",
              "Vanga Bhasma",
              "Lauha Bhasma",
              "Naradiya Laxmi Vilas Rasa",
              "Sameera Pannaga Rasa"
            ],
            [
              "Honey, warm water",
              "trikatu decoction",
              "ginger, tulasi water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Kaphavyadhi Chikitsa",
            "Baisajyaratnavali -- Kapharoga pp.105-106 (Saptachhadi, Vasadi, Nimbadi, Marichadi, Mustaadi)",
            "Ashtanga Hridaya -- Kaphavyadhi",
            "Sushruta Samhita -- Saptachhadi Yoga",
            "Chakradatta -- Nimbadi Kwatha"
          ]
        },
        {
          "name": "VATA-PITTA",
          "note": "(Movement + Inflammation)",
          "cells": [
            [
              "Sutashekhar Rasa",
              "Kamdudha + Ashwagandha",
              "Giloy Sat Tablet",
              "Praval Panchamrit Rasa",
              "Rasnasaptaka Gutika",
              "Shatavari Gutika"
            ],
            [
              "Ashwagandha + Amalaki blend",
              "Guduchi Churna",
              "Shatavari Churna",
              "Bala Churna",
              "Trikatu half dose",
              "Triphala Churna"
            ],
            [
              "Chandanadi Kwatha",
              "Navanga Kwatha (BRV p.108)",
              "Guduchyadi Kwatha (BRV p.108)",
              "Rasnasaptaka Kwatha",
              "Dashamoola Kwatha",
              "Shatavari Kwatha",
              "Chandanasaptaka Kwatha"
            ],
            [
              "Chandanasava",
              "Balarishta",
              "Drakshasava",
              "Ashwagandharishta",
              "Useerasava",
              "Saraswatarishta"
            ],
            [
              "Ksheerabala Taila (SY p.70)",
              "Balaguduchyadi Taila (SY p.73)",
              "Chandanadi Ghrita",
              "Mahanarayan Taila",
              "Dhanvantara Taila",
              "Tikta Ghrita"
            ],
            [
              "Sutashekhar Rasa",
              "Kamdudha Rasa",
              "Vasant Kusumakar Rasa",
              "Praval Panchamrit Rasa",
              "Abhraka Bhasma",
              "Mukta Pishti"
            ],
            [
              "Cool milk with ghee",
              "pomegranate + sesame",
              "amalaki juice"
            ]
          ],
          "source": [
            "Charaka Samhita -- Vatapittavyadhi",
            "Baisajyaratnavali pp.100-102, 108 (Navanga Kwatha, Guduchyadi Kwatha)",
            "Sahasra Yoga -- Ksheerabala Taila p.70; Balaguduchyadi Taila p.73",
            "Ashtanga Hridaya -- Vata-Pitta Chikitsa"
          ]
        },
        {
          "name": "PITTA-KAPHA",
          "note": "(Heat + Congestion)",
          "cells": [
            [
              "Kanchanar Guggulu",
              "Arogyavardhini Vati",
              "Triphala Guggulu",
              "Guduchi Sat Tablet",
              "Praval Panchamrit Rasa",
              "Haridra Khanda Tablet",
              "Shilajit Tablet"
            ],
            [
              "Haridra Churna",
              "Triphala Churna",
              "Kutki Churna",
              "Neem Churna",
              "Kalmegh Churna",
              "Guduchi Churna",
              "Pushkaramoola Churna"
            ],
            [
              "Nimbadi Kwatha",
              "Patoladi Kwatha",
              "Tiktadi Kwatha",
              "Arogyavardhini Kwatha",
              "Kakolyadi Kwatha",
              "Punarnavadi Kwatha",
              "Kutakadi Kwatha"
            ],
            [
              "Kumaryasava",
              "Lohasava",
              "Punarnavasava",
              "Khadirarishta",
              "Kanakasava",
              "Arjunarishta"
            ],
            [
              "Nisosiradi Taila (SY p.77 -- Prameha, Meda)",
              "Panchavalkadi Taila (SY p.75)",
              "Tikta Ghrita",
              "Mahatikta Ghrita",
              "Jatyadi Taila",
              "Nirgundi Taila",
              "Haridra Taila"
            ],
            [
              "Arogyavardhini Vati",
              "Tamra Bhasma",
              "Abhraka Bhasma",
              "Lauha Bhasma",
              "Naradiya Laxmi Vilas Rasa",
              "Shilajit Shuddha",
              "Vanga Bhasma"
            ],
            [
              "Honey + warm water",
              "triphala decoction",
              "tulasi + ginger"
            ]
          ],
          "source": [
            "Charaka Samhita -- Pitta-Kapha Chikitsa",
            "Sahasra Yoga -- Nisosiradi Taila p.77; Panchavalkadi Taila p.75",
            "Baisajyaratnavali -- Pitta-Kapha pp.101-106",
            "Chakradatta -- Nimbadi, Patoladi Kwatha",
            "Ashtanga Hridaya -- Pitta-Kapha Vyadhi"
          ]
        },
        {
          "name": "VATA-KAPHA",
          "note": "(Dryness + Congestion Swasa, Kasa)",
          "cells": [
            [
              "Kanchanar Guggulu",
              "Yogaraj Guggulu",
              "Chitrakadi Vati",
              "Sitopaladi + Ashwagandha",
              "Varunadi Gutika",
              "Trikatu Vati",
              "Mahayogaraj Guggulu"
            ],
            [
              "Trikatu Churna",
              "Dashamoola Churna",
              "Sitopaladi Churna",
              "Vidanga Churna",
              "Pushkaramoola Churna",
              "Vacha Churna",
              "Ajamoda Churna"
            ],
            [
              "Dashamoola Kwatha",
              "Varunadi Kwatha",
              "Swasa-Kasahara Kwatha (SY p.22)",
              "Kanakasava related Kwatha",
              "Punarnavadi Kwatha",
              "Brihad Panchamoola Kwatha",
              "Nimbadi Kwatha"
            ],
            [
              "Kanakasava",
              "Balarishta",
              "Dashmoolaishta",
              "Lohasava",
              "Arjunarishta",
              "Punarnavasava"
            ],
            [
              "Karpasasthyadi Taila (SY p.74 -- Vata-Kapha)",
              "Tintrini Swarasadi Taila (SY p.79 -- Sarva Vataroga)",
              "Prabhanjana Vimardhana Taila (SY p.71)",
              "Mahanarayan Taila",
              "Nirgundi Taila",
              "Sahacharadi Taila"
            ],
            [
              "Shilajit Shuddha",
              "Abhraka Bhasma",
              "Vanga Bhasma",
              "Tamra Bhasma",
              "Lauha Bhasma",
              "Naradiya Laxmi Vilas Rasa"
            ],
            [
              "Honey + ginger",
              "warm water",
              "tulasi + sitopala",
              "eranda oil"
            ]
          ],
          "source": [
            "Sahasra Yoga -- Swasa-Kasahara Kashaya p.22; Karpasasthyadi Taila p.74; Tintrini Taila p.79; Prabhanjana Taila p.71",
            "Charaka Samhita -- Vata-Kapha Chikitsa",
            "Baisajyaratnavali -- Swasa-Kasa chapter",
            "Ashtanga Hridaya -- Swasaroga"
          ]
        },
        {
          "name": "TRIDOSHA",
          "note": "(All Three Doshas General Balancer)",
          "cells": [
            [
              "Triphala Guggulu",
              "Arogyavardhini Vati",
              "Sanjivani Vati",
              "Dashamoola Gutika",
              "Navaka Guggulu",
              "Sudarshana Ghan Vati",
              "Maha Sudarshana Vati"
            ],
            [
              "Triphala Churna",
              "Sitopaladi Churna",
              "Trikatu Churna",
              "Dashamoola Churna",
              "Chyawanprash Avleha",
              "Shatavari + Ashwagandha blend",
              "Guduchi Churna"
            ],
            [
              "Shadanga Paniya (SY p.15 -- Jwara, Tridosha)",
              "Tridosha Jwarahara Kwatha (SY p.17)",
              "Navanga Kwatha (BRV p.108)",
              "Dashamoola Kwatha",
              "Guduchyadi Kwatha Brihat",
              "Triphala Kwatha",
              "Sudarshana Kwatha",
              "Amruta Kwatha"
            ],
            [
              "Dashmoolaishta",
              "Drakshasava",
              "Amruta Arishta",
              "Lohasava",
              "Abhayarishta",
              "Saraswatarishta"
            ],
            [
              "Ashtamangala Ghritam (SY p.230 -- Rasayana, Tridosha)",
              "Trikatu Ghrita",
              "Brahmi Ghrita",
              "Shatavari Ghrita",
              "Triphala Ghrita",
              "Chyawanprash Ghrita"
            ],
            [
              "Jwarankusha Rasa (SY p.173 -- Sannipata Jwara)",
              "Ramabana Rasa (SY p.173 -- Sannipata, Tridosha)",
              "Vasant Kusumakar Rasa",
              "Abhraka Bhasma",
              "Praval Panchamrit Rasa",
              "Suvarna Malini Vasant",
              "Brihat Kasturabhairav Rasa"
            ],
            [
              "Warm water, honey",
              "ghee, cow milk",
              "amalaki juice",
              "triphala decoction"
            ]
          ],
          "source": [
            "Sahasra Yoga -- Shadanga Paniya p.15; Tridosha Jwara Kashaya p.17; Navanga Kwatha p.108; Ashtamangala Ghritam p.230; Jwarankusha Rasa p.173; Ramabana Rasa p.173",
            "Charaka Samhita -- Jwara Chikitsa",
            "Ashtanga Hridaya -- Jwara Chikitsa",
            "Baisajyaratnavali -- Navanga Kwatha p.108"
          ]
        }
      ]
    },
    {
      "section": "SAPTA DHATU — Seven Bodily Tissues",
      "rows": [
        {
          "name": "RASA DHATU",
          "note": "(Plasma / Lymph Nourishment, Immunity)",
          "cells": [
            [
              "Drakshasava Tablet",
              "Shatavari Gutika",
              "Jeevantyadi Gutika",
              "Amruta Gutika",
              "Guduchi Sat Tablet",
              "Chyawanprash Tablet",
              "Amruta Bhallataka Tablet"
            ],
            [
              "Shatavari Churna",
              "Amalaki Churna",
              "Guduchi Churna",
              "Draksha Churna",
              "Jeevaniya Churna",
              "Triphala Churna",
              "Rasayana Churna"
            ],
            [
              "Rasayana Kwatha",
              "Guduchyadi Kwatha",
              "Jeevantyadi Kwatha",
              "Shatavari Kwatha",
              "Amruta Kwatha",
              "Drakshaadi Kwatha",
              "Pancha Tikta Kwatha"
            ],
            [
              "Drakshasava",
              "Amruta Arishta",
              "Dashmoolarishta",
              "Jeevantyadi Asava",
              "Kumaryasava",
              "Abhayarishta"
            ],
            [
              "Maha Mayura Ghritam (SY p.231 -- Rasayana, Dhatu Poshana)",
              "Shatavari Ghrita",
              "Jeevaniya Ghrita",
              "Chyawanprash Ghrita",
              "Amruta Ghrita",
              "Brahmi Ghrita",
              "Ksheerabala Taila Oral"
            ],
            [
              "Vasant Kusumakar Rasa",
              "Suvarna Malini Vasant",
              "Abhraka Bhasma",
              "Praval Panchamrit Rasa",
              "Mukta Pishti",
              "Hiranya Bhasma",
              "Swarna Bhasma trace"
            ],
            [
              "Cow milk, mishri",
              "shatavari milk",
              "draksharasa (grape juice)",
              "amalaki juice"
            ]
          ],
          "source": [
            "Charaka Samhita -- Rasayana Adhyaya; Jeevaniya Mahakashaya",
            "Sahasra Yoga -- Maha Mayura Ghritam p.231 (Rasayana, Dhatu Poshana)",
            "Ashtanga Hridaya -- Rasayana Pada",
            "Bhavaprakasha -- Jeevaniya Dravyas",
            "Baisajyaratnavali -- Rasayana chapter"
          ]
        },
        {
          "name": "RAKTA DHATU",
          "note": "(Blood Oxygenation, Vitality)",
          "cells": [
            [
              "Arogyavardhini Vati",
              "Mandura Vataka",
              "Loha Bhasma Tablet",
              "Navayas Lauha",
              "Punarnavadi Mandura",
              "Khadirarishta Tablet",
              "Sarivadi Vati"
            ],
            [
              "Manjistha Churna",
              "Lodhra Churna",
              "Sariva Churna",
              "Anantamoola Churna",
              "Kutki Churna",
              "Neem Churna",
              "Triphala Churna"
            ],
            [
              "Raktapittahara Kwatha (SY p.18)",
              "Pradarahara Kwatha (SY p.19)",
              "Sarivadi Kwatha-Sushruta (BRV p.107)",
              "Manjishthadi Kwatha",
              "Patoladi Kwatha",
              "Khadiradi Kwatha",
              "Nimbadi Kwatha",
              "Anantamoola Kwatha"
            ],
            [
              "Lohasava",
              "Sarivadyasava",
              "Khadirarishta",
              "Drakshasava",
              "Kumaryasava",
              "Parthadyarishta"
            ],
            [
              "Pinda Taila (SY p.75 -- Raktapitta, Kushta)",
              "Panchavalkadi Taila (SY p.75 -- Raktapitta-pradhana Kushta)",
              "Manjishthadi Taila",
              "Saribadi Ghrita",
              "Mahatikta Ghrita",
              "Chandanadi Taila",
              "Kumkumadi Taila"
            ],
            [
              "Mandura Bhasma",
              "Praval Pishti",
              "Mukta Pishti",
              "Lauha Bhasma",
              "Abhraka Bhasma Shataputi",
              "Roupya Bhasma",
              "Praval Panchamrit Rasa"
            ],
            [
              "Pomegranate juice",
              "honey, mishri",
              "triphala decoction",
              "amalaki juice"
            ]
          ],
          "source": [
            "Charaka Samhita -- Raktapitta Chikitsa",
            "Sahasra Yoga -- Raktapittahara Kashaya pp.18-19; Pinda Taila p.75; Panchavalkadi Taila p.75",
            "Baisajyaratnavali -- Sarivadi Kwatha p.107 (Sushruta)",
            "Ashtanga Hridaya -- Raktavyadhi"
          ]
        },
        {
          "name": "MAMSA DHATU",
          "note": "(Muscle Strength, Bulk)",
          "cells": [
            [
              "Ashwagandha Gutika",
              "Bala Gutika",
              "Kapikacchu Tablet",
              "Musali Pak Tablet",
              "Shatavari Gutika",
              "Chyawanprash Avleha",
              "Ashtavarga Compound"
            ],
            [
              "Ashwagandha Churna",
              "Bala Churna",
              "Shatavari Churna",
              "Kapikacchu Churna",
              "Musali Churna",
              "Triphala Churna",
              "Rasayana Churna"
            ],
            [
              "Dashamoola Kwatha",
              "Balaadi Kwatha",
              "Balaguduchyadi Kwatha (SY p.73)",
              "Ashwagandha Kwatha",
              "Ashtavarga Kwatha",
              "Satavari Kwatha",
              "Saptachhadi Kwatha-Sushruta"
            ],
            [
              "Balarishta",
              "Ashwagandharishta",
              "Dashamoola Arishta",
              "Drakshasava",
              "Saraswatarishta",
              "Lohasava"
            ],
            [
              "Ashwagandhadi Ghrita",
              "Mahanarayan Taila",
              "Ksheerabala Taila (SY p.70 -- Vataroga, Sutika roga)",
              "Bala Taila",
              "Mahamasha Taila",
              "Ajamamsa Ghritam (SY p.232 -- Dhatu kshaya)",
              "Maha Mayura Ghritam (SY p.231)"
            ],
            [
              "Vasant Kusumakar Rasa",
              "Suvarna Malini Vasant",
              "Abhraka Bhasma",
              "Makardhwaj",
              "Vanga Bhasma",
              "Praval Bhasma"
            ],
            [
              "Warm milk, ghee",
              "urad dal water",
              "sesame oil"
            ]
          ],
          "source": [
            "Charaka Samhita -- Brimhaniya Varga",
            "Sahasra Yoga -- Ksheerabala Taila p.70; Balaguduchyadi Taila p.73; Ajamamsa Ghritam p.232; Maha Mayura Ghritam p.231",
            "Ashtanga Hridaya -- Mamsa Varga",
            "Bhavaprakasha"
          ]
        },
        {
          "name": "MEDA DHATU",
          "note": "(Fat Tissue Metabolism, Lubrication)",
          "cells": [
            [
              "Medohar Guggulu",
              "Triphala Guggulu",
              "Kanchanar Guggulu",
              "Navaka Guggulu",
              "Chandraprabha Vati",
              "Varanadi Guggulu",
              "Chitrakadi Vati"
            ],
            [
              "Trikatu Churna",
              "Triphala Churna",
              "Pushkaramoola Churna",
              "Guduchi Churna",
              "Vidanga Churna",
              "Methi Churna",
              "Guggulu Churna"
            ],
            [
              "Varunadi Kwatha",
              "Punarnavadi Kwatha",
              "Dashamoolakatutrayadi Kwatha",
              "Guduchyadi Kwatha",
              "Triphala Kwatha",
              "Patoladi Kwatha",
              "Musthakarishta related Kwatha"
            ],
            [
              "Kumaryasava",
              "Lohasava",
              "Punarnavasava",
              "Drakshasava",
              "Dashamoolarishta",
              "Musthakarishta (SY Therapeutic Index p.237)"
            ],
            [
              "Nisosiradi Taila (SY p.77 -- Prameha, Meda)",
              "Guggulu Taila",
              "Karpuradi Taila",
              "Nirgundi Taila",
              "Tikta Ghrita",
              "Vyoshadi Taila"
            ],
            [
              "Lauha Bhasma",
              "Vanga Bhasma",
              "Abhraka Bhasma",
              "Praval Bhasma",
              "Mandura Bhasma",
              "Tamra Bhasma"
            ],
            [
              "Warm water, honey",
              "ginger, trikatu",
              "triphala decoction"
            ]
          ],
          "source": [
            "Charaka Samhita -- Prameha Chikitsa; Sthaulya Chikitsa",
            "Sahasra Yoga -- Nisosiradi Taila p.77; Therapeutic Index p.237 (Musthakarishta)",
            "Ashtanga Hridaya -- Sthaulya",
            "Baisajyaratnavali -- Prameha chapter"
          ]
        },
        {
          "name": "ASTHI DHATU",
          "note": "(Bone Structure, Support)",
          "cells": [
            [
              "Laksha Guggulu",
              "Yogaraj Guggulu",
              "Praval Bhasma Tablet",
              "Mahayogaraj Guggulu",
              "Chandraprabha Vati",
              "Guggulu Shuddha",
              "Trayodashanga Guggulu"
            ],
            [
              "Ashwagandha Churna",
              "Laksha Churna",
              "Praval Bhasma Churna",
              "Bala Churna",
              "Hadjod / Asthishrinkhala Churna",
              "Arjuna Churna",
              "Shatavari Churna"
            ],
            [
              "Dashamoola Kwatha",
              "Guduchyadi Kwatha",
              "Tintrini Swarasadi Kwatha (SY p.79 -- Sarva Vataroga)",
              "Lakshadi Kwatha",
              "Rasnasaptaka Kwatha",
              "Baladi Kwatha",
              "Mahanarayana Kwatha"
            ],
            [
              "Balarishta",
              "Dashmoolarishta",
              "Ashwagandharishta",
              "Dashamoola Arishta",
              "Drakshasava",
              "Saraswatarishta"
            ],
            [
              "Mahanarayan Taila",
              "Ketakyadi Taila (SY p.71 -- Asthigata Vata)",
              "Tintrini Swarasadi Taila (SY p.79)",
              "Sahacharadi Taila",
              "Lakshadi Taila (SY p.74)",
              "Dhanvantara Taila",
              "Ksheerabala Taila",
              "Prasaranyadi Taila"
            ],
            [
              "Praval Bhasma",
              "Mukta Bhasma",
              "Shankha Bhasma",
              "Asthishrinkhala Bhasma",
              "Abhraka Bhasma",
              "Praval Panchamrit Rasa"
            ],
            [
              "Sesame oil, warm milk",
              "ghee, calcium-rich foods",
              "sesame seeds"
            ]
          ],
          "source": [
            "Sahasra Yoga -- Ketakyadi Taila p.71 (Asthigata Vata); Tintrini Taila & Kwatha p.79; Lakshadi Taila p.74",
            "Charaka Samhita -- Asthivyadhi",
            "Ashtanga Hridaya -- Asthivyadhi",
            "Baisajyaratnavali -- Asthivyadhi chapter"
          ]
        },
        {
          "name": "MAJJA DHATU",
          "note": "(Bone Marrow / Nervous Tissue)",
          "cells": [
            [
              "Brahmi Gutika",
              "Jatamansi Tablet",
              "Ashwagandha Gutika",
              "Shankhpushpi Tablet",
              "Manasamitra Vatakam",
              "Saraswata Gutika",
              "Brahmi Vati Swarna Yukta"
            ],
            [
              "Brahmi Churna",
              "Jatamansi Churna",
              "Shankhpushpi Churna",
              "Ashwagandha Churna",
              "Vacha Churna",
              "Guduchi Churna",
              "Kushmanda Churna"
            ],
            [
              "Brahmi Kwatha",
              "Saraswata Kwatha",
              "Balaguduchyadi Kwatha (SY p.73)",
              "Dashamoola Kwatha",
              "Jatamansi Kwatha",
              "Ashwagandha Kwatha",
              "Guduchyadi Kwatha"
            ],
            [
              "Saraswatarishta",
              "Ashwagandharishta",
              "Drakshasava",
              "Balarishta",
              "Abhayarishta",
              "Amrutarishta"
            ],
            [
              "Brahmi Ghrita",
              "Ashwagandhadi Ghrita",
              "Ksheerabala Avartana Taila (SY p.70 -- Rasayana, Indriya Prasadana)",
              "Saraswata Ghrita",
              "Jatamansyadi Ghrita",
              "Maha Mayura Ghritam (SY p.231 -- Indriya nasha)",
              "Vacha Taila",
              "Panchagavya Ghrita"
            ],
            [
              "Smriti Sagar Rasa",
              "Vasant Kusumakar Rasa",
              "Abhraka Bhasma Shataputi",
              "Suvarna Bhasma trace",
              "Manasamitra Vatakam",
              "Brahmi Vati Swarna",
              "Unmadagajankusha Rasa"
            ],
            [
              "Warm milk, ghee",
              "almond milk",
              "brahmi decoction, sesame"
            ]
          ],
          "source": [
            "Charaka Samhita -- Majjavyadhi; Medhya Rasayana",
            "Sahasra Yoga -- Ksheerabala Avartana Taila p.70; Maha Mayura Ghritam p.231 (Indriya nasha)",
            "Ashtanga Hridaya -- Rasayana",
            "Bhavaprakasha Vol 2"
          ]
        },
        {
          "name": "SHUKRA DHATU",
          "note": "(Reproductive Tissue Vitality, Fertility, Ojas)",
          "cells": [
            [
              "Kapikacchu Tablet",
              "Musali Pak Tablet",
              "Vanari Gutika",
              "Shatavari Gutika",
              "Ashwagandha Gutika",
              "Shilajit Tablet",
              "Chandraprabha Vati",
              "Vrishya Vati"
            ],
            [
              "Kapikacchu Churna",
              "Musali Churna",
              "Shatavari Churna",
              "Ashwagandha Churna",
              "Gokshura Churna",
              "Draksha Churna",
              "Triphala Churna"
            ],
            [
              "Gokshuradi Kwatha",
              "Shatavari Kwatha",
              "Musali Kwatha",
              "Swetapradarahara Kwatha (SY p.22 -- Shukradosha)",
              "Vrishya Kwatha",
              "Ashtavarga Kwatha",
              "Balaguduchyadi Kwatha"
            ],
            [
              "Drakshasava",
              "Ashwagandharishta",
              "Saraswatarishta",
              "Balarishta",
              "Lohasava",
              "Kumaryasava"
            ],
            [
              "Mridwikadi Ghritam (SY p.233 -- Shukra Vardhaka, Vrishya)",
              "Maha Mayura Ghritam (SY p.231)",
              "Shatavari Ghrita",
              "Ksheerabala Taila (SY p.70 -- Dhatu kshaya)",
              "Vanari Ghrita",
              "Ajamamsa Ghritam (SY p.232 -- Kshaya)",
              "Kapikacchu Ghrita",
              "Musali Ghrita"
            ],
            [
              "Vasant Kusumakar Rasa",
              "Suvarna Malini Vasant",
              "Vanga Bhasma",
              "Abhraka Bhasma",
              "Makardhwaj",
              "Swarna Bhasma trace",
              "Praval Bhasma"
            ],
            [
              "Warm milk with ghee",
              "saffron milk, urad dal",
              "amalaki + ashwagandha",
              "almonds"
            ]
          ],
          "source": [
            "Charaka Samhita -- Vrishya Adhyaya; Shukra Dosha Chikitsa",
            "Sahasra Yoga -- Mridwikadi Ghritam p.233 (Shukra Vardhaka); Maha Mayura Ghritam p.231; Ajamamsa Ghritam p.232; Swetapradarahara Kashaya p.22",
            "Ashtanga Hridaya -- Shukravyadhi",
            "Baisajyaratnavali -- Shukradosha"
          ]
        }
      ]
    },
    {
      "section": "AGNI — Digestive Fire",
      "rows": [
        {
          "name": "MANDAGNI",
          "note": "(Low Digestive Fire -- Kapha)",
          "cells": [
            [
              "Chitrakadi Vati",
              "Hingvasthaka Vati",
              "Lavangadi Vati",
              "Trikatu Vati",
              "Agni Tundi Vati",
              "Shankha Vati",
              "Bhaskara Lavana Vati"
            ],
            [
              "Hingvasthaka Churna",
              "Trikatu Churna",
              "Jatiphaladi Churna",
              "Lavana Bhaskar Churna",
              "Panchakola Churna",
              "Ajamoda Churna",
              "Vidangadi Churna"
            ],
            [
              "Chitrakadi Kwatha",
              "Pippalyadi Kwatha",
              "Deepaniya Kwatha",
              "Panchakola Kwatha",
              "Shunthi Kwatha",
              "Mustakadi Kwatha",
              "Shadanga Paniya (SY p.15)"
            ],
            [
              "Abhayarishta",
              "Jeerakadyarishta",
              "Kutajarishta",
              "Drakshasava",
              "Dashamoolarishta",
              "Kumaryasava"
            ],
            [
              "Hinguvachadi Ghrita",
              "Trikatu Ghrita",
              "Chitrakadi Ghrita",
              "Panchamoola Taila",
              "Eranda Taila",
              "Shatapushpa Ghrita"
            ],
            [
              "Agni Kumar Rasa",
              "Lavangadi Rasa",
              "Shankha Bhasma",
              "Tamra Bhasma",
              "Abhraka Bhasma",
              "Praval Bhasma"
            ],
            [
              "Warm water + ginger juice",
              "buttermilk (takra)",
              "rock salt + lime"
            ]
          ],
          "source": [
            "Charaka Samhita -- Agnimandya Chikitsa; Deepaniya Mahakashaya",
            "Sahasra Yoga -- Shadanga Paniya p.15",
            "Baisajyaratnavali -- Agnimandya chapter",
            "Ashtanga Hridaya -- Agnimandya"
          ]
        },
        {
          "name": "VISHAMAGNI",
          "note": "(Irregular Fire -- Vata)",
          "cells": [
            [
              "Hingvasthaka Vati",
              "Shankha Vati",
              "Lashunadi Vati",
              "Chitrakadi Vati",
              "Vatavidhvamsa Rasa",
              "Ajamoda Vati",
              "Trikatu Vati"
            ],
            [
              "Hingvasthaka Churna",
              "Ajamoda Churna",
              "Panchakola Churna",
              "Trikatu Churna",
              "Eranda Bija Churna",
              "Vayu Nashaka Churna",
              "Dashamoola Churna"
            ],
            [
              "Dashamoola Kwatha",
              "Pippalyadi Kwatha",
              "Balaadi Kwatha",
              "Ajamoda Kwatha",
              "Shunthi Kwatha",
              "Panchakola Kwatha",
              "Deepaniya Kwatha"
            ],
            [
              "Balarishta",
              "Dashmoolaishta",
              "Jeerakadyarishta",
              "Abhayarishta",
              "Drakshasava",
              "Lohasava"
            ],
            [
              "Hinguvachadi Ghrita",
              "Dashamoola Ghrita",
              "Eranda Taila",
              "Chitrakadi Ghrita",
              "Mahanarayan Taila",
              "Dhanvantara Taila"
            ],
            [
              "Agni Kumar Rasa",
              "Shankha Bhasma",
              "Vatavidhvamsa Rasa",
              "Abhraka Bhasma",
              "Tamra Bhasma",
              "Chitrakadi Rasa"
            ],
            [
              "Warm water + ghee",
              "ginger juice",
              "buttermilk (takra)"
            ]
          ],
          "source": [
            "Charaka Samhita -- Vatavyadhi; Grahani Chikitsa",
            "Ashtanga Hridaya -- Grahani; Vishamagni",
            "Baisajyaratnavali -- Udara Roga chapter",
            "Bhavaprakasha -- Grahani Dosha"
          ]
        },
        {
          "name": "TIKSHNAGNI",
          "note": "(High Fire -- Pitta)",
          "cells": [
            [
              "Kamdudha Rasa",
              "Praval Panchamrit Rasa",
              "Sutashekhar Rasa",
              "Avipattikar Tablet",
              "Shatavari Gutika",
              "Chandanadi Vati",
              "Shatari Rasa"
            ],
            [
              "Avipattikar Churna",
              "Shatavari Churna",
              "Yashtimadhu Churna",
              "Chandana Churna",
              "Amalaki Churna",
              "Draksha Churna",
              "Triphala Churna"
            ],
            [
              "Chandanadi Kwatha",
              "Avipattikar Kwatha",
              "Parpatakadi Kwatha (BRV p.101)",
              "Shatavari Kwatha",
              "Drakshaadi Kwatha",
              "Yashtimadhu Kwatha",
              "Licorice Kwatha"
            ],
            [
              "Chandanasava",
              "Useerasava",
              "Drakshasava",
              "Kumaryasava",
              "Parthadyarishta",
              "Lohasava"
            ],
            [
              "Tikta Ghrita",
              "Chandanadi Ghrita",
              "Shatavari Ghrita",
              "Yashtimadhu Ghrita",
              "Mahatikta Ghrita",
              "Brahmi Ghrita"
            ],
            [
              "Kamdudha Rasa",
              "Praval Pishti",
              "Mukta Pishti",
              "Praval Panchamrit",
              "Suvarna Sutashekhar Rasa",
              "Abhraka Bhasma"
            ],
            [
              "Coconut water",
              "cool milk + mishri",
              "fennel water",
              "pomegranate juice"
            ]
          ],
          "source": [
            "Charaka Samhita -- Pittavyadhi; Grahani Chikitsa",
            "Baisajyaratnavali -- Tikshnagni; Pittaroga pp.101-102",
            "Ashtanga Hridaya -- Pittavyadhi",
            "Bhavaprakasha -- Pittahara Dravyas"
          ]
        }
      ]
    },
    {
      "section": "AMA & OJAS",
      "rows": [
        {
          "name": "AMA PACHANA",
          "note": "(Toxin Digestion & Detoxification)",
          "cells": [
            [
              "Agni Tundi Vati",
              "Sanjivani Vati",
              "Hingvasthaka Vati",
              "Chitrakadi Vati",
              "Trikatu Vati",
              "Arogyavardhini Vati",
              "Navaka Guggulu"
            ],
            [
              "Trikatu Churna",
              "Triphala Churna",
              "Hingvasthaka Churna",
              "Panchakola Churna",
              "Sudarshana Churna",
              "Lavana Bhaskar Churna",
              "Vayu Nashaka Churna"
            ],
            [
              "Shadanga Paniya (SY p.15 -- Jwara, Ama)",
              "Sunthi Kwatha (ginger decoction)",
              "Sudarshana Kwatha",
              "Panchakola Kwatha",
              "Triphala Kwatha",
              "Amruta Kwatha",
              "Deepaniya Kwatha"
            ],
            [
              "Abhayarishta",
              "Jeerakadyarishta",
              "Dashmoolaishta",
              "Amruta Arishta",
              "Kutajarishta",
              "Drakshasava"
            ],
            [
              "Trikatu Ghrita",
              "Chitrakadi Ghrita",
              "Hinguvachadi Ghrita",
              "Amruta Ghrita",
              "Eranda Taila",
              "Panchakarma Abhyanga Taila"
            ],
            [
              "Sanjivani Rasa",
              "Agni Kumar Rasa",
              "Shankha Bhasma",
              "Tamra Bhasma",
              "Abhraka Bhasma",
              "Lauha Bhasma"
            ],
            [
              "Warm water + ginger",
              "honey (not heated)",
              "trikatu decoction"
            ]
          ],
          "source": [
            "Charaka Samhita -- Ama Vata; Deepaniya; Langhana Chikitsa",
            "Sahasra Yoga -- Shadanga Paniya p.15",
            "Ashtanga Hridaya -- Ama Vata; Langhana",
            "Baisajyaratnavali -- Ama chapter"
          ]
        },
        {
          "name": "OJAS KSHAYA",
          "note": "(Vital Essence & Immunity)",
          "cells": [
            [
              "Chyawanprash Tablet",
              "Shatavari Gutika",
              "Ashwagandha Gutika",
              "Vasant Kusumakar Tablet",
              "Bala Gutika",
              "Musali Pak Tablet",
              "Brahmi Vati"
            ],
            [
              "Ashwagandha Churna",
              "Shatavari Churna",
              "Amalaki Churna",
              "Musali Churna",
              "Bala Churna",
              "Triphala Churna",
              "Rasayana Churna"
            ],
            [
              "Jeevaniya Kwatha",
              "Shatavari Kwatha",
              "Ashtavarga Kwatha",
              "Balaguduchyadi Kwatha (SY p.73)",
              "Rasayana Kwatha",
              "Guduchyadi Kwatha",
              "Amruta Kwatha"
            ],
            [
              "Drakshasava",
              "Ashwagandharishta",
              "Balarishta",
              "Saraswatarishta",
              "Amruta Arishta",
              "Kumaryasava"
            ],
            [
              "Ashtamangala Ghritam (SY p.230 -- Rasayana)",
              "Maha Mayura Ghritam (SY p.231)",
              "Shatavari Ghrita",
              "Brahmi Ghrita",
              "Ajamamsa Ghritam (SY p.232)",
              "Ksheerabala Taila (SY p.70)",
              "Chyawanprash Ghrita"
            ],
            [
              "Vasant Kusumakar Rasa",
              "Suvarna Malini Vasant",
              "Swarna Bhasma trace",
              "Abhraka Bhasma",
              "Praval Panchamrit Rasa",
              "Hiranya Bhasma",
              "Mukta Pishti"
            ],
            [
              "Warm milk with ghee",
              "saffron milk",
              "honey + amalaki"
            ]
          ],
          "source": [
            "Charaka Samhita -- Ojakshaya Chikitsa; Rasayana Adhyaya",
            "Sahasra Yoga -- Ashtamangala Ghritam p.230; Maha Mayura Ghritam p.231; Ajamamsa Ghritam p.232",
            "Ashtanga Hridaya -- Ojas; Rasayana",
            "Bhavaprakasha -- Ojavardhaka Dravyas"
          ]
        }
      ]
    },
    {
      "section": "MANAS — Mind & Mental Health",
      "rows": [
        {
          "name": "MANAS-VATA",
          "note": "(Anxiety, Fear, Insomnia)",
          "cells": [
            [
              "Brahmi Vati",
              "Ashwagandha Gutika",
              "Jatamansi Tablet",
              "Shankhpushpi Tablet",
              "Manasamitra Vatakam",
              "Saraswata Gutika",
              "Tagara Vati"
            ],
            [
              "Ashwagandha Churna",
              "Brahmi Churna",
              "Jatamansi Churna",
              "Shankhpushpi Churna",
              "Tagara Churna",
              "Sarpagandha Churna",
              "Vacha Churna"
            ],
            [
              "Brahmi Kwatha",
              "Saraswata Kwatha",
              "Ashwagandha Kwatha",
              "Jatamansi Kwatha",
              "Tagara Kwatha",
              "Sarpagandha Kwatha",
              "Guduchyadi Kwatha"
            ],
            [
              "Saraswatarishta",
              "Ashwagandharishta",
              "Balarishta",
              "Abhayarishta",
              "Amrutarishta",
              "Drakshasava"
            ],
            [
              "Brahmi Ghrita",
              "Ashwagandhadi Ghrita",
              "Saraswata Ghrita",
              "Jatamansyadi Ghrita",
              "Ksheerabala Avartana Taila (SY p.70)",
              "Maha Mayura Ghritam (SY p.231)",
              "Vacha Taila"
            ],
            [
              "Smriti Sagar Rasa",
              "Manasamitra Vatakam",
              "Abhraka Bhasma Shataputi",
              "Suvarna Bhasma trace",
              "Unmadagajankusha Rasa",
              "Brahmi Vati Swarna",
              "Vasant Kusumakar Rasa"
            ],
            [
              "Warm milk + ashwagandha",
              "brahmi juice",
              "nutmeg milk",
              "sesame"
            ]
          ],
          "source": [
            "Charaka Samhita -- Unmada Chikitsa; Bhaya",
            "Sahasra Yoga -- Ksheerabala Avartana Taila p.70; Maha Mayura Ghritam p.231",
            "Ashtanga Hridaya -- Unmada; Bhaya",
            "Bhavaprakasha -- Medhya Rasayana Dravyas"
          ]
        },
        {
          "name": "MANAS-PITTA",
          "note": "(Anger, Irritability, Mania)",
          "cells": [
            [
              "Sarpagandha Vati",
              "Kamdudha Rasa",
              "Praval Panchamrit Rasa",
              "Brahmi Vati",
              "Sutashekhar Rasa",
              "Chandanadi Tablet",
              "Mukta Pishti Tablet"
            ],
            [
              "Sarpagandha Churna",
              "Brahmi Churna",
              "Shankhpushpi Churna",
              "Chandana Churna",
              "Jatamansi Churna",
              "Yashtimadhu Churna",
              "Amalaki Churna"
            ],
            [
              "Chandanadi Kwatha",
              "Saraswata Kwatha",
              "Brahmi Kwatha",
              "Sarpagandha Kwatha",
              "Jatamansi Kwatha",
              "Nimbadi Kwatha",
              "Guduchyadi Kwatha"
            ],
            [
              "Chandanasava",
              "Saraswatarishta",
              "Useerasava",
              "Drakshasava",
              "Ashwagandharishta",
              "Abhayarishta"
            ],
            [
              "Brahmi Ghrita",
              "Chandanadi Ghrita",
              "Tikta Ghrita",
              "Saraswata Ghrita",
              "Jatamansyadi Ghrita",
              "Mahatikta Ghrita",
              "Panchagavya Ghrita"
            ],
            [
              "Suvarna Sutashekhar Rasa",
              "Manasamitra Vatakam",
              "Praval Pishti",
              "Mukta Pishti",
              "Suvarna Malini Vasant",
              "Abhraka Bhasma Shataputi",
              "Unmadagajankusha Rasa"
            ],
            [
              "Cool milk + brahmi",
              "coconut water",
              "sandalwood water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Unmada Chikitsa; Krodha",
            "Ashtanga Hridaya -- Unmada; Pitta Manas",
            "Yogaratnakar -- Unmada Chikitsa",
            "Bhavaprakasha -- Medhya Rasayana"
          ]
        },
        {
          "name": "MANAS-KAPHA",
          "note": "(Depression, Lethargy, Grief)",
          "cells": [
            [
              "Brahmi Vati",
              "Vacha Vati",
              "Sarpagandha Vati",
              "Shankhpushpi Tablet",
              "Trikatu Vati",
              "Arogyavardhini Vati",
              "Musali Pak Tablet"
            ],
            [
              "Vacha Churna",
              "Brahmi Churna",
              "Shankhpushpi Churna",
              "Trikatu Churna",
              "Pushkaramoola Churna",
              "Vidanga Churna",
              "Guduchi Churna"
            ],
            [
              "Vacha Kwatha",
              "Brahmi Kwatha",
              "Shankhpushpi Kwatha",
              "Punarnavadi Kwatha",
              "Trikatu Kwatha",
              "Saraswata Kwatha",
              "Guduchyadi Kwatha"
            ],
            [
              "Saraswatarishta",
              "Abhayarishta",
              "Drakshasava",
              "Kanakasava",
              "Ashwagandharishta",
              "Lohasava"
            ],
            [
              "Vacha Taila",
              "Brahmi Ghrita",
              "Saraswata Ghrita",
              "Trikatu Ghrita",
              "Panchagavya Ghrita",
              "Nirgundi Taila",
              "Vyoshadi Ghrita"
            ],
            [
              "Manasamitra Vatakam",
              "Unmadagajankusha Rasa",
              "Abhraka Bhasma",
              "Swarna Bhasma trace",
              "Brahmi Vati Swarna",
              "Suvarna Malini Vasant",
              "Vacha Rasa"
            ],
            [
              "Honey + warm water",
              "brahmi + vacha",
              "ginger milk",
              "saffron"
            ]
          ],
          "source": [
            "Charaka Samhita -- Unmada; Vishada Chikitsa",
            "Ashtanga Hridaya -- Unmada; Kapha Manas",
            "Yogaratnakar -- Unmada Chikitsa",
            "Bhavaprakasha -- Medhya Rasayana; Vishada"
          ]
        }
      ]
    },
    {
      "section": "ORGAN SPECIFICS",
      "rows": [
        {
          "name": "HRIDAYA",
          "note": "(Heart Cardiac Support)",
          "cells": [
            [
              "Arjuna Tablet",
              "Hridayarnava Rasa Tablet",
              "Prabhakara Vati",
              "Chandraprabha Vati",
              "Mritasanjivani Vati",
              "Sarpagandha Vati",
              "Arjunarishta Tablet"
            ],
            [
              "Arjuna Churna",
              "Pushkarmool Churna",
              "Punarnava Churna",
              "Yashtimadhu Churna",
              "Shatavari Churna",
              "Hawthorn (Vrikshamla) Churna",
              "Triphala Churna"
            ],
            [
              "Arjunadi Kwatha",
              "Punarnavadi Kwatha",
              "Dashamoola Kwatha",
              "Parthadyadi Kwatha",
              "Hridyadi Kwatha",
              "Manjishthadi Kwatha",
              "Guduchyadi Kwatha"
            ],
            [
              "Arjunarishta",
              "Drakshasava",
              "Parthadyarishta",
              "Ashwagandharishta",
              "Abhayarishta",
              "Saraswatarishta"
            ],
            [
              "Arjuna Ghrita",
              "Hridyadi Ghrita",
              "Brahmi Ghrita",
              "Panchagavya Ghrita",
              "Shatavari Ghrita",
              "Ksheerabala Taila (SY p.70)",
              "Dhanvantara Taila"
            ],
            [
              "Hridayarnava Rasa",
              "Prabhakara Vati",
              "Mritasanjivani Rasa",
              "Praval Panchamrit Rasa",
              "Abhraka Bhasma",
              "Swarna Bhasma trace",
              "Vasant Kusumakar Rasa"
            ],
            [
              "Arjuna milk (ksheerpaka)",
              "warm cow milk",
              "saffron + honey"
            ]
          ],
          "source": [
            "Charaka Samhita -- Hridaya Roga Chikitsa; Hridaya Mahakashaya",
            "Ashtanga Hridaya -- Hridroga Chikitsa",
            "Baisajyaratnavali -- Hridroga chapter",
            "Sahasra Yoga -- Ksheerabala Taila p.70",
            "Bhavaprakasha -- Hridya Dravyas"
          ]
        },
        {
          "name": "YAKRIT",
          "note": "(Liver Hepatic Support)",
          "cells": [
            [
              "Arogyavardhini Vati",
              "Kumaryasava Tablet",
              "Punarnava Mandur",
              "Loha Bhasma Tablet",
              "Kalmegh Tablet",
              "Bhringaraj Tablet",
              "Phalatrikadi Vati"
            ],
            [
              "Kalmegh Churna",
              "Kutki Churna",
              "Bhumyamalaki Churna",
              "Bhringaraj Churna",
              "Punarnava Churna",
              "Haridra Churna",
              "Triphala Churna"
            ],
            [
              "Arogyavardhini Kwatha",
              "Punarnavashtaka Kwatha",
              "Kalmegh Kwatha",
              "Bhumyamalaki Kwatha",
              "Patoladi Kwatha",
              "Guduchyadi Kwatha",
              "Nimbadi Kwatha"
            ],
            [
              "Kumaryasava",
              "Lohasava",
              "Drakshasava",
              "Punarnavasava",
              "Khadirarishta",
              "Abhayarishta"
            ],
            [
              "Arogyavardhini Ghrita",
              "Tikta Ghrita",
              "Mahatikta Ghrita",
              "Kalyanaka Ghrita",
              "Phalatrikadi Ghrita",
              "Brahmi Ghrita",
              "Chandanadi Ghrita"
            ],
            [
              "Tamra Bhasma",
              "Mandura Bhasma",
              "Abhraka Bhasma",
              "Lauha Bhasma",
              "Praval Pishti",
              "Arogyavardhini Vati Rasa",
              "Triphala Guggulu"
            ],
            [
              "Aloe vera juice",
              "bitter gourd juice",
              "honey + warm water",
              "kutki decoction"
            ]
          ],
          "source": [
            "Charaka Samhita -- Kamala Chikitsa; Pandu Chikitsa",
            "Baisajyaratnavali -- Yakrit Pliha Roga",
            "Ashtanga Hridaya -- Kamala; Pandu",
            "Bhavaprakasha -- Yakrit Pliha Roga",
            "Yogaratnakar -- Kamala"
          ]
        },
        {
          "name": "VRIKKA",
          "note": "(Kidney & Urinary Tract)",
          "cells": [
            [
              "Gokshuradi Guggulu",
              "Chandraprabha Vati",
              "Punarnava Mandur",
              "Varunadi Guggulu",
              "Shilajit Tablet",
              "Mutrakricchrantaka Vati",
              "Gokshura Tablet"
            ],
            [
              "Gokshura Churna",
              "Punarnava Churna",
              "Varunadi Churna",
              "Chandraprabha Churna",
              "Kulatha Churna",
              "Palasha Churna",
              "Triphala Churna"
            ],
            [
              "Varunadi Kwatha",
              "Gokshuradi Kwatha",
              "Punarnavadi Kwatha",
              "Chandanadi Kwatha",
              "Mutrakricchrantaka Kwatha",
              "Pashana Bhed Kwatha",
              "Dashamoola Kwatha"
            ],
            [
              "Punarnavasava",
              "Kumaryasava",
              "Lohasava",
              "Gokshuradi Asava",
              "Chandanasava",
              "Abhayarishta"
            ],
            [
              "Gokshuradi Ghrita",
              "Punarnava Ghrita",
              "Varunadi Ghrita",
              "Chandanadi Ghrita",
              "Tikta Ghrita",
              "Ksheerabala Taila (SY p.70)",
              "Dhanvantara Taila"
            ],
            [
              "Chandraprabha Vati",
              "Shilajit Shuddha",
              "Abhraka Bhasma",
              "Tamra Bhasma",
              "Vanga Bhasma",
              "Praval Bhasma",
              "Mandura Bhasma"
            ],
            [
              "Coconut water",
              "barley water (yava jala)",
              "punarnava decoction",
              "coriander water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Mutrakriccha Chikitsa; Ashmari Chikitsa",
            "Baisajyaratnavali -- Mutraroga; Ashmari",
            "Ashtanga Hridaya -- Mutravaha Srotas",
            "Bhavaprakasha -- Mutra Vaha Srotas",
            "Yogaratnakar -- Mutrakriccha"
          ]
        },
        {
          "name": "PHUPPHUSA",
          "note": "(Lungs / Swasa Respiratory)",
          "cells": [
            [
              "Vasavaleha Tablet",
              "Kanakasava Tablet",
              "Sitopaladi Tablet",
              "Talisadi Tablet",
              "Swasananda Gutika",
              "Agastya Haritaki Tablet",
              "Dashamoola Gutika"
            ],
            [
              "Sitopaladi Churna",
              "Talisadi Churna",
              "Pushkaramoola Churna",
              "Pippalyadi Churna",
              "Vasavaleha (Avleha)",
              "Agastya Haritaki Churna",
              "Vasubahu Churna"
            ],
            [
              "Vasadi Kwatha (BRV p.106)",
              "Swasa-Kasahara Kwatha (SY p.22)",
              "Kanakasava Kwatha",
              "Dashamoola Kwatha",
              "Sitopaladi Kwatha",
              "Brihad Panchamoola Kwatha",
              "Nidigdhika Kwatha"
            ],
            [
              "Kanakasava",
              "Vasarishta",
              "Drakshasava",
              "Abhayarishta",
              "Dashmoolaishta",
              "Kumaryasava"
            ],
            [
              "Karpasasthyadi Taila (SY p.74 -- Swasa, Vata-Kapha)",
              "Nirgundi Taila",
              "Tulasi Taila",
              "Mahanarayan Taila",
              "Dhanvantara Taila",
              "Vasadi Ghrita",
              "Lakshmi Vilas Taila"
            ],
            [
              "Shwasa Kasa Chintamani Rasa",
              "Sameera Pannaga Rasa",
              "Abhraka Bhasma",
              "Vanga Bhasma",
              "Tamra Bhasma",
              "Kanaka Rasa",
              "Naradiya Laxmi Vilas Rasa"
            ],
            [
              "Honey + ginger",
              "tulasi + sitopala",
              "warm water + vasadi",
              "licorice decoction"
            ]
          ],
          "source": [
            "Charaka Samhita -- Swasa Chikitsa; Kasa Chikitsa",
            "Sahasra Yoga -- Swasa-Kasahara Kashaya p.22; Karpasasthyadi Taila p.74",
            "Baisajyaratnavali -- Swasa-Kasa chapter; Vasadi Kwatha p.106",
            "Ashtanga Hridaya -- Swasaroga; Kasaroga"
          ]
        },
        {
          "name": "TWAK",
          "note": "(Skin Kushtha, Dermatology)",
          "cells": [
            [
              "Khadirarishta Tablet",
              "Manjistha Tablet",
              "Arogyavardhini Vati",
              "Triphala Guggulu",
              "Neem Tablet",
              "Gandhaka Rasayan",
              "Mahamanjishthadi Tablet"
            ],
            [
              "Manjistha Churna",
              "Neem Churna",
              "Haridra Churna",
              "Sariva Churna",
              "Triphala Churna",
              "Anantamoola Churna",
              "Gandhaka Churna"
            ],
            [
              "Mahamanjishthadi Kwatha",
              "Khadiradi Kwatha",
              "Patoladi Kwatha",
              "Nimbadi Kwatha",
              "Sarivadi Kwatha (BRV p.107)",
              "Manjishthadi Kwatha",
              "Anantamoola Kwatha"
            ],
            [
              "Khadirarishta",
              "Sarivadyasava",
              "Drakshasava",
              "Lohasava",
              "Kumaryasava",
              "Parthadyarishta"
            ],
            [
              "Kumkumadi Taila",
              "Jatyadi Taila",
              "Manjishthadi Taila",
              "Nalpamaradi Taila",
              "Panchavalkadi Taila (SY p.75)",
              "Mahatikta Ghrita",
              "Chandanadi Taila"
            ],
            [
              "Gandhaka Rasayan",
              "Ras Manikya",
              "Tamra Bhasma",
              "Praval Pishti",
              "Lauha Bhasma",
              "Abhraka Bhasma",
              "Mandura Bhasma"
            ],
            [
              "Neem water",
              "triphala decoction",
              "amalaki juice + honey",
              "manjistha water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Kushtha Chikitsa",
            "Sahasra Yoga -- Panchavalkadi Taila p.75",
            "Baisajyaratnavali -- Kushtha chapter; Sarivadi Kwatha p.107",
            "Ashtanga Hridaya -- Kushtha Chikitsa",
            "Bhavaprakasha -- Twak Roga"
          ]
        },
        {
          "name": "NETRA",
          "note": "(Eyes Ophthalmic Health)",
          "cells": [
            [
              "Saptamrita Lauha Tablet",
              "Triphala Guggulu",
              "Chandrodaya Tablet",
              "Mahatriphala Ghrita Tablet",
              "Amalaki Rasayan Tablet",
              "Drishti Tablet",
              "Vidrumadi Rasa Tablet"
            ],
            [
              "Triphala Churna",
              "Shatavari Churna",
              "Amalaki Churna",
              "Yashtimadhu Churna",
              "Haridra Churna",
              "Mahatriphala Churna",
              "Hadjod Churna"
            ],
            [
              "Triphala Kwatha",
              "Saptamrita Kwatha",
              "Amalaki Kwatha",
              "Yashtimadhu Kwatha",
              "Chandanadi Kwatha",
              "Guduchyadi Kwatha",
              "Nimbadi Kwatha"
            ],
            [
              "Drakshasava",
              "Kumaryasava",
              "Abhayarishta",
              "Lohasava",
              "Amruta Arishta",
              "Parthadyarishta"
            ],
            [
              "Mahatriphala Ghrita (Netra Rasayana)",
              "Triphala Ghrita",
              "Yashtimadhu Ghrita",
              "Chandanadi Ghrita",
              "Saptamrita Lauha in Ghrita",
              "Brahmi Ghrita",
              "Shatavari Ghrita"
            ],
            [
              "Saptamrita Lauha",
              "Praval Pishti",
              "Mukta Pishti",
              "Abhraka Bhasma Shataputi",
              "Chandrodaya Rasa",
              "Vidrumadi Rasa",
              "Roupya Bhasma"
            ],
            [
              "Triphala water (netra wash)",
              "mishri + amalaki",
              "cool cow milk",
              "rose water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Timira Chikitsa; Netra Roga",
            "Ashtanga Hridaya -- Netra Chikitsa; Timira",
            "Baisajyaratnavali -- Netra Roga chapter",
            "Sahasra Yoga -- Mahatriphala Ghrita",
            "Yogaratnakar -- Netra Roga; Timira"
          ]
        },
        {
          "name": "SHIRA",
          "note": "(Head / Brain Neurological)",
          "cells": [
            [
              "Brahmi Vati Swarna Yukta",
              "Manasamitra Vatakam",
              "Shankhpushpi Tablet",
              "Ashwagandha Gutika",
              "Vacha Vati",
              "Sarpagandhadi Tablet",
              "Jatamansi Tablet"
            ],
            [
              "Brahmi Churna",
              "Shankhpushpi Churna",
              "Vacha Churna",
              "Ashwagandha Churna",
              "Jatamansi Churna",
              "Sarpagandha Churna",
              "Triphala Churna"
            ],
            [
              "Brahmi Kwatha",
              "Saraswata Kwatha",
              "Vacha Kwatha",
              "Shankhpushpi Kwatha",
              "Ashwagandha Kwatha",
              "Jatamansi Kwatha",
              "Dashamoola Kwatha"
            ],
            [
              "Saraswatarishta",
              "Ashwagandharishta",
              "Balarishta",
              "Drakshasava",
              "Abhayarishta",
              "Saraswatarishta"
            ],
            [
              "Ksheerabala Avartana Taila (SY p.70 -- Rasayana, Indriya)",
              "Brahmi Ghrita",
              "Saraswata Ghrita",
              "Maha Mayura Ghritam (SY p.231)",
              "Jatamansyadi Ghrita",
              "Vacha Taila",
              "Anu Taila (nasya)"
            ],
            [
              "Brahmi Vati Swarna",
              "Manasamitra Vatakam",
              "Smriti Sagar Rasa",
              "Vasant Kusumakar Rasa",
              "Abhraka Bhasma Shataputi",
              "Suvarna Bhasma trace",
              "Unmadagajankusha Rasa"
            ],
            [
              "Warm milk + brahmi",
              "almond + ashwagandha",
              "sesame nasya oil",
              "saffron milk"
            ]
          ],
          "source": [
            "Charaka Samhita -- Shiroroga Chikitsa; Medhya Rasayana",
            "Sahasra Yoga -- Ksheerabala Avartana Taila p.70; Maha Mayura Ghritam p.231",
            "Ashtanga Hridaya -- Shiroroga; Medhya",
            "Bhavaprakasha -- Medhya Rasayana Dravyas",
            "Baisajyaratnavali -- Shiroroga chapter"
          ]
        }
      ]
    },
    {
      "section": "ADDITIONAL ORGAN SPECIFICS",
      "rows": [
        {
          "name": "KESHA",
          "note": "(Hair Keshya, Scalp)",
          "cells": [
            [
              "Bhringaraj Tablet",
              "Amalaki Rasayan Tablet",
              "Triphala Guggulu",
              "Keshya Tablet",
              "Shatavari Gutika",
              "Loha Bhasma Tablet",
              "Brahmi Vati"
            ],
            [
              "Bhringaraj Churna",
              "Amalaki Churna",
              "Brahmi Churna",
              "Triphala Churna",
              "Haritaki Churna",
              "Shatavari Churna",
              "Guduchi Churna"
            ],
            [
              "Bhringarajadi Kwatha",
              "Amalaki Kwatha",
              "Triphala Kwatha",
              "Manjishthadi Kwatha",
              "Guduchyadi Kwatha",
              "Nimbadi Kwatha",
              "Shatavari Kwatha"
            ],
            [
              "Lohasava",
              "Kumaryasava",
              "Drakshasava",
              "Ashwagandharishta",
              "Abhayarishta",
              "Khadirarishta"
            ],
            [
              "Neelibhringadi Taila (Kerala -- Keshya Rasayana)",
              "Mahabhringaraj Taila",
              "Brahmi Taila",
              "Amalaki Taila",
              "Triphaladi Taila",
              "Nimba Taila",
              "Bhringaraj Ghrita"
            ],
            [
              "Lauha Bhasma",
              "Mandura Bhasma",
              "Abhraka Bhasma",
              "Praval Bhasma",
              "Saptamrita Lauha",
              "Mukta Pishti"
            ],
            [
              "Amalaki juice",
              "bhringaraj decoction",
              "sesame oil (shiro abhyanga)",
              "coconut milk"
            ]
          ],
          "source": [
            "Charaka Samhita -- Keshya Mahakashaya; Shiroroga",
            "Bhavaprakasha -- Kesha Roga",
            "Ashtanga Hridaya -- Shiroroga; Palitya",
            "Baisajyaratnavali -- Kesha Roga; Palitya chapter"
          ]
        },
        {
          "name": "KARNA",
          "note": "(Ear Auditory Health)",
          "cells": [
            [
              "Triphala Guggulu",
              "Saptamrita Lauha Tablet",
              "Chandraprabha Vati",
              "Patoladi Tablet",
              "Dashamoola Gutika",
              "Sariva Tablet",
              "Mahamanjishthadi Tablet"
            ],
            [
              "Triphala Churna",
              "Yashtimadhu Churna",
              "Bilva Churna",
              "Shatavari Churna",
              "Haridra Churna",
              "Neem Churna",
              "Guduchi Churna"
            ],
            [
              "Triphala Kwatha",
              "Patoladi Kwatha",
              "Nimbadi Kwatha",
              "Guduchyadi Kwatha",
              "Dashamoola Kwatha",
              "Karnadi Kwatha",
              "Manjishthadi Kwatha"
            ],
            [
              "Drakshasava",
              "Kumaryasava",
              "Abhayarishta",
              "Saraswatarishta",
              "Lohasava",
              "Dashmoolaishta"
            ],
            [
              "Bilva Taila (karna purna -- classical ear drops)",
              "Sarshapa Taila (mustard -- karna purna)",
              "Dashamoola Taila",
              "Nirgundi Taila",
              "Ksheerabala Taila (SY p.70)",
              "Sahacharadi Taila",
              "Anu Taila"
            ],
            [
              "Saptamrita Lauha",
              "Praval Pishti",
              "Abhraka Bhasma",
              "Mukta Pishti",
              "Roupya Bhasma",
              "Tamra Bhasma"
            ],
            [
              "Warm bilva taila (ear drops)",
              "warm sarshapa taila",
              "sesame oil + garlic"
            ]
          ],
          "source": [
            "Charaka Samhita -- Karnaroga Chikitsa",
            "Ashtanga Hridaya -- Karnaroga; Karna Pratishedha",
            "Sushruta Samhita -- Karnaroga",
            "Baisajyaratnavali -- Karna Roga chapter",
            "Bhavaprakasha -- Karna Roga"
          ]
        },
        {
          "name": "GALA GANDA",
          "note": "(Thyroid / Goitre Galaganda)",
          "cells": [
            [
              "Kanchanar Guggulu",
              "Triphala Guggulu",
              "Arogyavardhini Vati",
              "Gandamala Kandana Rasa Tablet",
              "Varunadi Vati",
              "Chandraprabha Vati",
              "Shilajit Tablet"
            ],
            [
              "Kanchanara Churna",
              "Triphala Churna",
              "Vacha Churna",
              "Haridra Churna",
              "Vidanga Churna",
              "Guggulu Churna",
              "Pushkaramoola Churna"
            ],
            [
              "Varunadi Kwatha",
              "Kanchanaradi Kwatha",
              "Punarnavadi Kwatha",
              "Guduchyadi Kwatha",
              "Nimbadi Kwatha",
              "Patoladi Kwatha",
              "Triphala Kwatha"
            ],
            [
              "Kumaryasava",
              "Lohasava",
              "Punarnavasava",
              "Khadirarishta",
              "Drakshasava",
              "Abhayarishta"
            ],
            [
              "Kanchanaradi Ghrita",
              "Tikta Ghrita",
              "Mahatikta Ghrita",
              "Nirgundi Taila (external)",
              "Guggulu Taila",
              "Varunadi Ghrita"
            ],
            [
              "Gandamala Kandana Rasa",
              "Tamra Bhasma",
              "Abhraka Bhasma",
              "Shilajit Shuddha",
              "Lauha Bhasma",
              "Vanga Bhasma",
              "Kanchanar Guggulu Rasa"
            ],
            [
              "Warm water + honey",
              "kanchanara decoction",
              "varuna bark decoction"
            ]
          ],
          "source": [
            "Charaka Samhita -- Galaganda Chikitsa; Gala Roga",
            "Sushruta Samhita -- Galaganda; Granthi Roga",
            "Ashtanga Hridaya -- Gala Roga; Galaganda",
            "Baisajyaratnavali -- Galaganda chapter",
            "Bhavaprakasha -- Galaganda; Gandamala"
          ]
        },
        {
          "name": "ASTHI-SANDHI",
          "note": "(Bones & Joints Sandhivata, Amavata)",
          "cells": [
            [
              "Yogaraj Guggulu",
              "Mahayogaraj Guggulu",
              "Simhanada Guggulu",
              "Laksha Guggulu",
              "Trayodashanga Guggulu",
              "Rasnasaptaka Gutika",
              "Vata Vidhvamsa Rasa"
            ],
            [
              "Dashamoola Churna",
              "Rasna Churna",
              "Ashwagandha Churna",
              "Eranda Churna",
              "Trikatu Churna",
              "Hingvasthaka Churna",
              "Shallaki Churna"
            ],
            [
              "Rasnasaptaka Kwatha",
              "Dashamoola Kwatha",
              "Amavata Nashaka Kwatha",
              "Guduchyadi Kwatha",
              "Punarnavadi Kwatha",
              "Balaadi Kwatha",
              "Eranda Kwatha"
            ],
            [
              "Balarishta",
              "Dashmoolaishta",
              "Ashwagandharishta",
              "Eranda Taila Sneha",
              "Saraswatarishta",
              "Lohasava"
            ],
            [
              "Mahanarayan Taila",
              "Ksheerabala Taila (SY p.70 -- Sandhivata)",
              "Sahacharadi Taila",
              "Dhanvantara Taila",
              "Prasaranyadi Taila",
              "Rasnadi Taila",
              "Pinda Taila"
            ],
            [
              "Vata Vidhvamsa Rasa",
              "Mahavata Vidhwansan Rasa",
              "Brihad Vata Chintamani",
              "Ekanga Veer Rasa",
              "Abhraka Bhasma",
              "Praval Bhasma",
              "Yogendra Rasa"
            ],
            [
              "Warm sesame oil",
              "castor oil + ginger",
              "eranda taila in milk",
              "warm water"
            ]
          ],
          "source": [
            "Charaka Samhita -- Vatavyadhi Chikitsa; Amavata Chikitsa",
            "Sahasra Yoga -- Ksheerabala Taila p.70; Tintrini Kwatha p.79",
            "Baisajyaratnavali -- Amavata; Sandhivata chapter",
            "Ashtanga Hridaya -- Vatavyadhi; Sandhi Shotha"
          ]
        }
      ]
    }
  ]
};

export default MEDICINE_MATRIX;
